import { AllCompaniesThemeModeConfig } from './types';

const light: AllCompaniesThemeModeConfig = {
  allCompanies: {},
};

export default light;
